/**
 * AAA IDP Footer component
 * 
 */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ErrorApi.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ErrorApi = function (props) {
  const {
    apiError,
    page
  } = props;
  const button = page === 'payment' ? page : 'application';
  if (!apiError) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "pre-footer error",
    children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: "triangle-exclamation",
      inverse: true,
      className: "left"
    }), "We're sorry, there was an error with your application.", /*#__PURE__*/_jsx("br", {}), "Please click ", /*#__PURE__*/_jsxs("strong", {
      children: ["\"CANCEL ", button, "\""]
    }), " and start again."]
  });
};
ErrorApi.defaultProps = {
  apiError: false,
  page: 'details'
};
export default ErrorApi;